"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.approveInvoice = approveInvoice;
exports.createCreditNote = createCreditNote;
exports.createInvoice = createInvoice;
exports["default"] = void 0;
exports.deleteFeeFromInvoice = deleteFeeFromInvoice;
exports.deleteInvoice = deleteInvoice;
exports.deleteInvoiceItem = deleteInvoiceItem;
exports.deleteInvoicePayment = deleteInvoicePayment;
exports.disapproveInvoice = disapproveInvoice;
exports.exportAllInvoices = exportAllInvoices;
exports.getAllInvoices = getAllInvoices;
exports.getContractInvoices = getContractInvoices;
exports.getInvoice = getInvoice;
exports.getLinkedInvoice = getLinkedInvoice;
exports.getProjectInvoices = getProjectInvoices;
exports.getSendInvoiceData = getSendInvoiceData;
exports.publishInvoiceSent = publishInvoiceSent;
exports.requestInvoiceApproval = requestInvoiceApproval;
exports.sendInvoice = sendInvoice;
exports.setCreatedStatus = setCreatedStatus;
exports.setCreditNoteToApprovedStatus = setCreditNoteToApprovedStatus;
exports.updateInvoice = updateInvoice;
exports.updateInvoiceItems = updateInvoiceItems;
exports.updatePayments = updatePayments;

var _api = _interopRequireWildcard(require("./api"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getInvoice(id) {
  return _api["default"].get("/api/invoice/".concat(id)).then(_api.extractData)["catch"](_api.errorHandler);
}

function createInvoice(invoiceData) {
  return _api["default"].post('/api/invoice', _objectSpread({}, invoiceData)).then(_api.extractData)["catch"](_api.errorHandler);
}

function updateInvoice(invoiceData) {
  return _api["default"].put('/api/invoice/' + invoiceData.id, _objectSpread({}, invoiceData)).then(_api.extractData)["catch"](_api.errorHandler);
}

function deleteInvoice(invoiceId) {
  return _api["default"]["delete"]("/api/invoice/".concat(invoiceId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function deleteInvoiceItem(invoiceItemId) {
  return _api["default"]["delete"]("/api/invoice-item/".concat(invoiceItemId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function deleteFeeFromInvoice(invoiceId, feeId) {
  return _api["default"]["delete"]("/api/invoice/".concat(invoiceId, "/fees/").concat(feeId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getProjectInvoices(projectId) {
  return _api["default"].get('/api/project/' + projectId + '/invoices?includeFees=true&includeInvoiceItems=true').then(_api.extractData)["catch"](_api.errorHandler);
}

function getContractInvoices(contractId) {
  return _api["default"].get('/api/contract/' + contractId + '/invoices?includeFees=true&includeInvoiceItems=true').then(_api.extractData)["catch"](_api.errorHandler);
}

function updateInvoiceItems(invoiceId, invoiceItems) {
  return _api["default"].put("/api/invoice/".concat(invoiceId, "/invoice-items"), {
    invoiceItems: invoiceItems
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function requestInvoiceApproval(invoiceId) {
  return _api["default"].put("/api/invoice/".concat(invoiceId, "/request-approval")).then(_api.extractData)["catch"](_api.errorHandler);
}

function approveInvoice(invoiceId) {
  return _api["default"].put("/api/invoice/".concat(invoiceId, "/approve")).then(_api.extractData)["catch"](_api.errorHandler);
}

function disapproveInvoice(invoiceId, disapprovedReason) {
  return _api["default"].put("/api/invoice/".concat(invoiceId, "/disapprove"), {
    disapprovedReason: disapprovedReason
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function setCreatedStatus(invoiceId, data) {
  return _api["default"].put("/api/invoice/".concat(invoiceId, "/created-status"), data).then(_api.extractData)["catch"](_api.errorHandler);
}

function getSendInvoiceData(invoiceId) {
  return _api["default"].get("/api/invoice/".concat(invoiceId, "/send-invoice")).then(_api.extractData)["catch"](_api.errorHandler);
}

function sendInvoice(invoiceId, sendingData) {
  return _api["default"].put("/api/invoice/".concat(invoiceId, "/send-invoice"), sendingData).then(_api.extractData)["catch"](_api.errorHandler);
}

function publishInvoiceSent(invoiceId) {
  return _api["default"].get("/api/invoice/".concat(invoiceId, "/publish-invoice-sent")).then(_api.extractData)["catch"](_api.errorHandler);
}

function updatePayments(invoiceId, invoicePayments) {
  return _api["default"].put("/api/invoice/".concat(invoiceId, "/invoice-payments"), {
    invoicePayments: invoicePayments
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function deleteInvoicePayment(invoiceId, invoicePaymentId) {
  return _api["default"]["delete"]("/api/invoice/".concat(invoiceId, "/invoice-payments/").concat(invoicePaymentId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function createCreditNote(invoiceId, data) {
  return _api["default"].post("/api/invoice/".concat(invoiceId, "/credit-note"), data).then(_api.extractData)["catch"](_api.errorHandler);
}

function setCreditNoteToApprovedStatus(invoiceId, invoiceDates) {
  return _api["default"].put("/api/invoice/".concat(invoiceId, "/approved-credit-note"), invoiceDates).then(_api.extractData)["catch"](_api.errorHandler);
}

function getLinkedInvoice(invoiceId) {
  return _api["default"].get("/api/invoice/".concat(invoiceId, "/linked-invoice")).then(_api.extractData)["catch"](_api.errorHandler);
}

function getAllInvoices() {
  return _api["default"].get("/api/invoice/invoice-listing").then(_api.extractData)["catch"](_api.errorHandler);
}

function exportAllInvoices(data) {
  return _api["default"].post("/api/invoice/invoice-export", data).then(_api.extractData)["catch"](_api.errorHandler);
}

var api = {
  get: getInvoice,
  create: createInvoice,
  update: updateInvoice,
  "delete": deleteInvoice,
  deleteInvoiceItem: deleteInvoiceItem,
  getProjectInvoices: getProjectInvoices,
  getContractInvoices: getContractInvoices,
  updateInvoiceItems: updateInvoiceItems,
  requestApproval: requestInvoiceApproval,
  approve: approveInvoice,
  disapprove: disapproveInvoice,
  setCreatedStatus: setCreatedStatus,
  getSendInvoiceData: getSendInvoiceData,
  sendInvoice: sendInvoice,
  updatePayments: updatePayments,
  deleteInvoicePayment: deleteInvoicePayment,
  createCreditNote: createCreditNote,
  setCreditNoteToApprovedStatus: setCreditNoteToApprovedStatus,
  getLinkedInvoice: getLinkedInvoice,
  getAllInvoices: getAllInvoices,
  deleteFeeFromInvoice: deleteFeeFromInvoice,
  publishInvoiceSent: publishInvoiceSent
};
var _default = api;
exports["default"] = _default;